class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.quantityInput = this.form.querySelector('input[name="quantity"]');
    this.variantIdInput = this.form.querySelector('input[name="id"]');
    this.fieldsets = this.querySelectorAll('fieldset');

    // Get all submit buttons that are part of the form
    this.submitButtons = document.querySelectorAll(
      `button[form="${this.form.getAttribute('id')}"]`
    );

    this.form.addEventListener('submit', (event) => this.onFormSubmit(event));

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        const productForm = html.querySelector('product-form');
        //allow user to finish selecting options before replacing the form

        if (this.areAllOptionsSelected()) {
          this.replaceWith(productForm);
        } else {
          //replace all options data-variant-ids with the new ones based on matching option value id
          this.fieldsets.forEach((fieldset) => {
            fieldset.querySelectorAll('[data-variant-id]').forEach((option) => {
              if (fieldset.dataset.optionName === option.closest('fieldset').dataset.optionName) {
                const matchingOption = productForm.querySelector(
                  `[data-option-value-id="${option.dataset.optionValueId}"]`
                );
                if (matchingOption) {
                  option.dataset.variantId = matchingOption.dataset.variantId;
                }
              }
            });
          });
        }
      }
    );

    this.unsubscribeQuantityChange = subscribe('quantity:change', ({ quantity }) => {
      this.quantityInput.value = quantity;
    });
  }

  areAllOptionsSelected() {
    return Array.from(this.fieldsets).every((fieldset) => {
      const checkedOption = fieldset.querySelector('[data-variant-id]:checked');
      return checkedOption !== null;
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    this.unsubscribeQuantityChange();
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async onFormSubmit(event) {
    event.preventDefault();
    this.toggleLoading(true);

    try {
      const formData = this.createFormData();
      const itemData = await this.addToCart(formData);
      this.onSuccess(itemData, formData.items[0].quantity);
    } catch (error) {
      this.onError(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  toggleLoading(loading) {
    this.submitButtons.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Create form data
   * @returns {Object}
   */
  createFormData() {
    // Get all property inputs
    const propertyInputs = this.querySelectorAll('[name^="properties"]');
    const properties = {};

    // Build properties object from inputs
    propertyInputs.forEach((input) => {
      const propertyName = input.name.match(/properties\[(.*?)\]/)[1];
      properties[propertyName] = input.value;
    });

    return {
      items: [
        {
          id: this.variantIdInput.value,
          quantity: this.quantityInput.value,
          properties,
        },
      ],
    };
  }

  /**
   * Add to cart
   * @param {Object} formData
   * @returns {Object}
   */
  async addToCart(formData) {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to add to cart');
    return data;
  }

  /**
   * Handle form success
   */
  onSuccess(itemData, quantity) {
    window.toast.success(window.toast_translations.cart.success);
    publish('cart:added', {
      items: itemData.items,
      quantity,
    });
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  onError({ message }) {
    console.error(message);
    window.toast.error(message);
  }
}

customElements.define('product-form', ProductForm);
